import React from 'react';
import logo from '../images/PayLOGIKreversedwhite.png';
import {Link as RouterLink} from 'react-router-dom';
import {styled} from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import {useTheme} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {CanI, canIFunc, action} from '../CanI';
import {useAppDispatch, useAppSelector} from '../redux/functions/hooks';
import {logout} from '../redux/store/authSlice';
import {useGetIa360ReportingLinkQuery} from '../redux/rtkquery/paylogikApi';
//TODO: Get username from state
//TODO: Update links once pages are built

const navButtons = [
    {
        name: 'Dashboard',
        link: '/',
        local: true,
        functionId: '',
        action: action.VIEW,
    },
    {
        name: 'Invoice Research',
        link: '/invoices',
        local: true,
        functionId: 'Webfrm_InvoiceResearch',
        action: action.VIEW,
    },
    {
        name: 'Approve Invoices',
        link: '/approveinvoices',
        local: true,
        functionId: 'Webfrm_ApproveInv',
        action: action.VIEW,
    },
    {
        name: 'Reporting',
        link: process.env.REACT_APP_REPORTING_PORTAL_URL,
        local: false,
        functionId: '',
        action: action.VIEW,
    },
    {
        name: 'Parcel Reporting',
        local: false,
        functionId: 'Web_I360A',
        action: action.VIEW,
        useIaUrl: true,
    },
    {
        name: 'Match Pay',
        link: '/matchpay',
        local: true,
        functionId: 'Webfrm_MatchPay',
        action: action.VIEW,
    },
];
const carrierLinks = [
    {
        name: 'Manage Exceptions',
        link: '/manageExceptions',
        local: true,
        functionId: 'Frm_ExceptionMgr',
        action: action.VIEW,
    },
];
const userLinks = [
    {
        name: 'IT Admin',
        link: '/itadmin',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Carrier Admin',
        link: '/carrierAdmin',
        local: true,
        functionId: 'Frm_ManageCarriers',
        action: action.VIEW,
    },
    {
        name: 'Customer Admin',
        link: '/customerAdmin',
        local: true,
        functionId: 'Frm_ManageBillTo',
        action: action.VIEW,
    },
    {
        name: 'Admin Forms',
        link: '/adminForms',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Manage App Defaults',
        link: '/appdefaults',
        local: true,
        functionId: 'Frm_ManageAppDefaults',
        action: action.VIEW,
    },
    {
        name: 'Settings',
        link: '/usersettings',
        local: true,
        functionId: '',
        action: action.VIEW,
    },
];

const StyledToolbar = styled(Toolbar)(({theme}) => ({
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    // Override media queries injected by theme.mixins.toolbar
}));

const LinkBehavior = React.forwardRef((props, ref) => {
    if (props.page) {
        if (props.page.local)
            return <RouterLink ref={ref} to={props.page.link} {...props} />;
        else {
            return (
                <Link
                    href={props.page.useIaUrl ? props.iaurl : props.page.link}
                    target="_blank"
                    rel="noreferrer"
                    {...props}
                />
            );
        }
    } else {
        return <></>;
    }
});

const ExpandableMenu = ({
    buttonId,
    menuId,
    anchorElement,
    links,
    handleOpen,
    handleClose,
    theme,
    auth,
}) => {
    const shownLinks = links.filter((link) => {
        return canIFunc(auth, link.functionId, link.action);
    });

    return shownLinks.length > 0 ? (
        <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
            <Button
                id={buttonId}
                variant="text"
                key={buttonId}
                onClick={handleOpen}
                sx={{
                    my: 2,
                    color: 'white',
                    fontSize: theme.typography.h6.fontSize,
                }}
                endIcon={<KeyboardArrowDownIcon />}>
                Carrier
            </Button>
            <Menu
                sx={{mt: '45px'}}
                id={menuId}
                anchorEl={anchorElement}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElement)}
                onClose={handleClose}>
                {shownLinks.map((page) => (
                    <MenuItem
                        key={'settings'}
                        onClick={handleClose}
                        component={LinkBehavior}
                        page={page}>
                        <Typography textAlign="center">{page.name}</Typography>
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    ) : (
        <></>
    );
};

export default function Header(props) {
    const theme = useTheme();

    const auth = useAppSelector((x) => x.auth);
    const displayName = auth.displayName;
    const initials = auth.initials;
    const dispatch = useAppDispatch();

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorElCarrier, setAnchorElCarrier] = React.useState(null);

    const {data: iaUrl} = useGetIa360ReportingLinkQuery({});

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleOpenCarrierMenu = (event) => {
        setAnchorElCarrier(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const handleCloseCarrierMenu = () => {
        setAnchorElCarrier(null);
    };

    return (
        <AppBar position="static">
            <Container maxWidth="xl">
                <StyledToolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{mr: 2, display: {xs: 'none', md: 'flex'}}}>
                        <img src={logo} alt=""></img>
                    </Typography>

                    <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit">
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: {xs: 'block', md: 'none'},
                            }}>
                            {navButtons.map((page) => (
                                <CanI
                                    id={page.name}
                                    functionId={page.functionId}
                                    action={page.action}>
                                    <MenuItem
                                        key={page.name}
                                        onClick={handleCloseNavMenu}
                                        component={LinkBehavior}
                                        page={page}
                                        iaurl={iaUrl}>
                                        <Typography textAlign="center">
                                            {page.name}
                                        </Typography>
                                    </MenuItem>
                                </CanI>
                            ))}
                        </Menu>
                    </Box>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                        <img src={logo} alt=""></img>
                    </Typography>
                    <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
                        {navButtons.map((page) => (
                            <CanI
                                id={page.name}
                                functionId={page.functionId}
                                action={page.action}>
                                <Button
                                    id={page.name}
                                    variant="text"
                                    key={page.name}
                                    onClick={handleCloseNavMenu}
                                    sx={{
                                        my: 2,
                                        color: 'white',
                                        fontSize: theme.typography.h6.fontSize,
                                    }}
                                    component={LinkBehavior}
                                    page={page}
                                    iaurl={iaUrl}>
                                    {page.name}
                                </Button>
                            </CanI>
                        ))}
                    </Box>

                    <ExpandableMenu
                        buttonId="carrierMenu"
                        menuId="menu-carrier"
                        anchorElement={anchorElCarrier}
                        links={carrierLinks}
                        handleOpen={handleOpenCarrierMenu}
                        handleClose={handleCloseCarrierMenu}
                        theme={theme}
                        auth={auth}
                    />

                    <Box sx={{flexGrow: 0}}>
                        <Tooltip title="Open settings">
                            <IconButton
                                onClick={handleOpenUserMenu}
                                sx={{p: 0}}>
                                <Avatar alt={displayName}>{initials}</Avatar>
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{mt: '45px'}}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}>
                            {userLinks.map((page) => (
                                <CanI
                                    id={page.name}
                                    functionId={page.functionId}
                                    action={page.action}>
                                    <MenuItem
                                        key={'settings'}
                                        onClick={handleCloseUserMenu}
                                        component={LinkBehavior}
                                        page={page}>
                                        <Typography textAlign="center">
                                            {page.name}
                                        </Typography>
                                    </MenuItem>
                                </CanI>
                            ))}
                            <MenuItem
                                key={'Log Out'}
                                onClick={() => {
                                    handleCloseUserMenu();
                                    dispatch(logout());
                                }}>
                                <Typography textAlign="center">
                                    Log Out
                                </Typography>
                            </MenuItem>
                        </Menu>
                    </Box>
                </StyledToolbar>
            </Container>
        </AppBar>
    );
}
